import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { IFramework, IFrameworkResource } from "../types";

export type IFrameworkDuplicateMutationParameters = {
    framework: RelationalValue<IFrameworkResource>;
};

export type IFrameworkDuplicateMutationResult = IFramework;

export const frameworkDuplicateMutation: IApiMutationFunction<IFrameworkDuplicateMutationParameters> = ({
    framework,
}) => {
    return {
        method: "POST",
        url: "/frameworks/duplicate",
        data: { uuid: mapRelationalValue(framework) },
    };
};

export const useFrameworkDuplicateMutation = createApiMutationHook<
    IFrameworkDuplicateMutationParameters,
    IFrameworkDuplicateMutationResult
>(frameworkDuplicateMutation);
